{
  "seat": {
    "nav": "工位",
    "title": "Kinio Station 工位",
    "subtitle": "只读：数据来自 dev plane 的租约中心与各站回报。执行工具、租用 DUT 请用 kst。",
    "not_found": "找不到这个页面",
    "plane_down": "连不上 dev plane（{{code}}），读不到工位数据。要看某一站，在那台站上打开本机工位页 {{url}}。",
    "loading": "读取中…",
    "view_stations": "按站",
    "view_resources": "按资源",
    "col_station": "站",
    "col_model": "机种",
    "col_version": "tools 版本",
    "col_online": "连线",
    "col_mode": "模式",
    "col_resources": "资源（忙 / 全部）",
    "col_running": "正在运行",
    "col_leases": "租约",
    "online": "在线",
    "offline": "离线",
    "last_seen": "最后上线 {{ago}} 前",
    "mode_seat": "工位模式",
    "mode_full": "完整",
    "prob_offline": "离线",
    "prob_duplicate": "资源 id 重复",
    "prob_tools_down": "tools 程序没在运行",
    "running_item": "{{tool}}（{{caller}}，{{ago}}）",
    "lease_item": "{{name}}：{{holder}}（{{purpose}}，到 {{until}}）",
    "col_dut": "DUT",
    "col_type": "类型",
    "col_state": "状态",
    "col_holder": "租用者",
    "col_purpose": "用途",
    "col_expires": "到期",
    "state_free": "空闲",
    "state_busy": "使用中",
    "state_offline": "离线",
    "dup_hint": "红色的 DUT 有两台以上的站回报：租约中心不会发放它的租约，请改掉其中一台的登记。",
    "leases_err": "读不到租约中心（{{code}}），租约栏改用各站回报的摘要（可能落后 30 秒）。",
    "empty": "—",
    "back": "← 全部工位",
    "detail_info": "站信息",
    "hostname": "主机名称",
    "lan": "局域网地址",
    "modules": "模块",
    "ui_home": "本机首页",
    "detail_resources": "资源",
    "detail_tools": "工具（只列出，不执行）",
    "col_tool": "工具",
    "col_tier": "等级",
    "col_summary": "说明",
    "tools_err": "读不到工具清单（{{code}}）",
    "detail_runs": "最近执行",
    "col_caller": "发起者",
    "col_started": "开始",
    "col_ended": "结束",
    "show_output": "看输出",
    "hide_output": "收起",
    "output_empty": "（没有输出）",
    "output_truncated": "（只显示前 256 KB）",
    "output_err": "读不到输出（{{code}}）",
    "runs_err": "读不到最近执行（{{code}}）",
    "screenshot": "远程截图",
    "screenshot_busy": "截图中…",
    "screenshot_err": "截图失败（{{code}}）",
    "screenshot_err_UI_NOT_RUNNING": "Station 的画面没开（nvr-ui 没在运行），没有画面可截。",
    "kst_hint": "要操作这台：kst show {{name}}",
    "station_missing": "这台不在你看得到的工位里。",
    "run_running": "执行中",
    "run_succeeded": "成功",
    "run_failed": "失败",
    "run_cancelled": "已取消",
    "run_timeout": "超时",
    "screenshot_err_SCREEN_TOO_LARGE": "画面太大（超过 8 MB），不取回。"
  }
}
